module.exports = __webpack_public_path__ + "img/pic8.93525526.jpg";